import { matchRoutes, useParams } from 'react-router-dom';

import { useMediaQuery } from '@datanomik/commons-ui';

import { APP_ROUTES } from '@/assets/MenuItems';

import { useRouteMatch } from '@/hooks/useRouteMatch';
import { useTargetElement } from '@/hooks/useTargetElement';

const getAppSidebarMenuElement = () => document.getElementById('App-Slot-Sidebar-Menu');

export const useSidebarMenu = ({ location }) => {
  const { workspace } = useParams();
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const isMobileMd = useMediaQuery((theme) => theme.breakpoints.down('md'));

  const menuMatchRoutes = matchRoutes(APP_ROUTES, `/${workspace}/${location}`);

  const { length, [length - 1]: routeItem } = menuMatchRoutes;
  const showTabletTabs = useMediaQuery((theme) => theme.breakpoints.between('sm', 'md'));

  const { targetElement: sidebarMenuElement } = useTargetElement(
    getAppSidebarMenuElement,
  );

  const { params, route } = useRouteMatch(APP_ROUTES);
  const extraLocation = `${location}/${route.path}`;
  const currentTab = `/${params?.workspace}/${route?.parent || extraLocation}`;

  return {
    routeItem,
    isMobile,
    currentTab,
    isMobileMd,
    showTabletTabs,
    sidebarMenuElement,
  };
};
